import { Component, OnDestroy, OnInit, ViewChild, ChangeDetectorRef, ElementRef, Input, Pipe, PipeTransform, Output, EventEmitter, ViewEncapsulation, AfterViewInit } from '@angular/core';
import { UsersService } from '../../services/users.service'
import { ActivatedRoute, Router } from '@angular/router';
import { GlobalSearchService } from '../../services/globalsearchservice.service'
import { GlobalsService } from '../../services/globals.service'
import { UntypedFormBuilder, Validators, ControlContainer, FormGroupDirective, FormControl, UntypedFormGroup, ReactiveFormsModule } from '@angular/forms';
import { Location } from '@angular/common'
import { MatCardModule } from '@angular/material/card';


@Component({
	selector: 'app-user-create',
	templateUrl: './user-create.component.html',
	styleUrls: ['./user-create.component.scss']
})




export class UserCreateComponent implements OnInit {
	title = 'New User';
	user: any = [];
	users: any = [];
	userForm: UntypedFormGroup;
	systemForm: UntypedFormGroup;
	userdetails: any = [];
	locations: any = [];
	userlocations: any = [];
	usergroups: any = [];
	yesno: any = [
		{ value: '0', name: 'No' },
		{ value: '1', name: 'Yes' }
	];

	formEditAllowed = [
		'userid',
		'password',
		'realname',
		'phone',
		'email',
		'defaultlocation',
		'fullaccess',
		'cancreatetender',
		'editinv',
		'dispatchadmin',
		'customeradmin',
		'user_group',
		'empcode',
		'salesman'
		//'phoneno',
	]

	userid: any = '';
	color: any = 'blue';
	defaultlocation: any;
	recs: any = [];
	activeStep: any;
	emailRegex = '^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$';
	phoneRegex = '^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4}$';
	empcodes: any = false;

	constructor(private route: ActivatedRoute, private formBuilder: UntypedFormBuilder, private userService: UsersService, public router: Router, private location: Location, public globalSearchService: GlobalSearchService, private globalsService: GlobalsService) {
		this.color = this.globalSearchService.getColor();
	}

	ngOnInit(): void {
		this.userForm = this.formBuilder.group({
			userid: ['', [Validators.required, Validators.pattern('[-_a-zA-Z0-9]*')]],
			password: ['', Validators.required],
			realname: ['', Validators.required],
			phone: ['', Validators.pattern(this.phoneRegex)],
			email: ['', Validators.pattern(this.emailRegex)],
		});

		this.systemForm = this.formBuilder.group({
			defaultlocation: ['', Validators.required],
			fullaccess: ['3', Validators.required],
			empcode: [''],
			salesman: [''],
			user_group: ['', Validators.required],
			customeradmin: ['1'],
			cancreatetender: ['1'],
			editinv: ['1'],
			dispatchadmin: ['0'],
			isPOSUser: [false],
			isSalesman: [false],
			commissionrate1: [''],
			csremails: [''],
			commlock: [0],
			chatid: [''],
			group_id: ['1'],
			group_level: ['0'],
			group_type: ['1'],
		});

		this.userForm.markAllAsTouched();
		this.systemForm.markAllAsTouched();
		this.user['locations'] = [];

		this.getEmployeeCodes();

		this.systemForm.get('isPOSUser')?.valueChanges.subscribe(enabled => {
			const ctrl = this.systemForm.get('empcode');
			if (enabled) {

			} else {
				ctrl?.clearValidators();
				ctrl?.reset();
			}
			ctrl?.updateValueAndValidity();
			ctrl?.markAsTouched();
		});

		this.systemForm.get('isSalesman')?.valueChanges.subscribe(enabled => {
			const fields = [
				'salesman', 'commissionrate1', 'csremails', 'commlock',
				'chatid', 'group_id', 'group_level', 'group_type'
			];
			const emailUser = this.userForm.get('email');

			if (enabled) {
				this.systemForm.get('salesman')?.setValidators([Validators.required]);
				//this.systemForm.get('csremails')?.setValidators([Validators.required]);
				//emailUser?.setValidators([Validators.required, Validators.pattern(this.emailRegex)]);
			} else {
				this.systemForm.get('salesman')?.clearValidators();
				this.systemForm.get('csremails')?.clearValidators();
				emailUser?.setValidators([Validators.pattern(this.emailRegex)]);
				fields.forEach(field => this.systemForm.get(field)?.reset());
			}

			fields.forEach(field => {
				const ctrl = this.systemForm.get(field);
				ctrl?.updateValueAndValidity();
				ctrl?.markAsTouched();
			});
			emailUser?.updateValueAndValidity();
			emailUser?.markAsTouched();
		});

		this.systemForm.get('empcode').valueChanges.subscribe((newV)=>{
			if(Object.keys(this.empcodes).includes(newV) && newV !== ''){
				this.systemForm.get('empcode').setErrors({"error": true});
			}else{
				this.systemForm.get('empcode').setErrors(null);
				this.systemForm.updateValueAndValidity();
			}
		})
	}

	loading = false;

	getEmployeeCodes(){
		this.userService.getUsers().subscribe((res: any)=>{
			var codes = [];
			res.forEach(emp => {
				codes[emp.empcode] = emp.userid
			});
			this.empcodes = codes;
			console.log(codes);
			
		})
	}

	createUser() {
		if (this.userForm.valid && this.systemForm.valid && !this.loading) {
			this.loading = true;

			const formData = {
				...this.userForm.value,
				...this.systemForm.value
			};

			this.userService.createUser(this.user.userid, formData).subscribe({
				next: (results) => {
					this.user.user = results;
					this.globalSearchService.showNotification('Updated', 'success', 'bottom', 'right');
					this.updateLocations();
					this.location.back();
				},
				error: (err) => {
					console.error('Create user failed:', err);
					this.globalSearchService.showNotification('Failed to create user', 'danger', 'bottom', 'right');
				},
				complete: () => {
					this.loading = false;
				}
			});
		}
	}

	ngAfterViewInit() {
		this.globalsService.getLocations().subscribe(details => {
			this.locations = details;

		});

		this.globalsService.getAllLocations().subscribe(details => {
			this.recs = details;
		});

		this.userService.getUserGroups().subscribe(groups => {
			this.usergroups = groups;
		});
	}

	updateLocations() {

		const data = {
			userid: this.userid == '' ? this.userForm.get('userid').value : this.userid,
			locations: this.user.locations
		};


		this.userService.updateUserLocations(data).subscribe((user: any) => {
			this.user = user;
		});
	}

	addUserLocation(loc: any) {
		const index = this.locations.indexOf(loc)
		this.locations.splice(index, 1);
		this.user.locations.push(loc)

		this.sortlocations();
	}

	addAllLocation(loc: any) {
		this.user.locations = this.locations;
	}

	removeUserLocation(loc: any) {

		if (loc == this.defaultlocation) {
			alert('Can not remove default location from the list.');
			return;
		}
		const index = this.user.locations.indexOf(loc)
		this.user.locations.splice(index, 1);
		this.locations.push(loc)
		this.sortlocations();

	}

	sortlocations() {
		this.locations.sort((n1, n2) => n1.loccode - n2.loccode);
		this.user.locations.sort((n1, n2) => n1.loccode - n2.loccode);
	}

	defaultLocation(event: any): void {
		if (!event?.value || !Array.isArray(this.locations) || !Array.isArray(this.user?.locations)) {return;}
	
		const newLocCode = event.value;
	
		// Find the new default location (from either list)
		const newLocation = this.locations.find(loc => loc.loccode === newLocCode)
			|| this.user.locations.find(loc => loc.loccode === newLocCode);
	
		if (!newLocation || (this.defaultlocation?.loccode === newLocCode)) {return;}
	
		// Move previous default back to location pool if it exists
		if (this.defaultlocation) {
			this.locations.push(this.defaultlocation);
			this.user.locations = this.user.locations.filter(loc => loc.loccode !== this.defaultlocation.loccode);
		}
	
		// Remove new location from existing pools to avoid duplication
		this.locations = this.locations.filter(loc => loc.loccode !== newLocCode);
		this.user.locations = this.user.locations.filter(loc => loc.loccode !== newLocCode);
	
		// Set new default and push to user locations
		this.defaultlocation = newLocation;
		this.user.locations.push(newLocation);
	
		this.sortlocations();
	}

	onSubmit() {

	}

	back(): void {
		this.location.back()
	}

	translate_yn(input: any) {
		if (input == 0 || input == 1) {
			return input == 0 ? 'No' : 'Yes';
		} else {
			return '?';
		}
	}

	translate_usergroup(input: any) {
		if (input != '') {
			return this.usergroups.filter(group => (group['user_group_id'] == input))[0]['name'];
		} else {
			return '';
		}
	}

	logStep(event: any) {
		this.activeStep = event.selectedIndex;
	}

	format_phone(input: HTMLInputElement): void {
		if (!input || typeof input.value !== 'string') {return;}
	
		const digits = input.value.replace(/\D/g, '').slice(0, 10); // limit to 10 digits max
	
		let formatted = '';
	
		if (digits.length >= 6) {
			formatted = `(${digits.slice(0, 3)})${digits.slice(3, 6)}-${digits.slice(6)}`;
		} else if (digits.length >= 3) {
			formatted = `(${digits.slice(0, 3)})${digits.slice(3)}`;
		} else {
			formatted = digits;
		}
	
		input.value = formatted;
	}


}